/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Draw_DescInputs */

const en_home_features_draw_desc = /** @type {(inputs: Home_Features_Draw_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All the core drawing commands, with keyword prompts, command history, AutoComplete and aliases. Enter coordinates as x,y, @dx,dy, @distance<angle or #x,y, or simply point in a direction and type a distance.`)
};

/**
* | output |
* | --- |
* | "All the core drawing commands, with keyword prompts, command history, AutoComplete and aliases. Enter coordinates as x,y, @dx,dy, @distance<angle or #x,y, or..." |
*
* @param {Home_Features_Draw_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_features_draw_desc = /** @type {((inputs?: Home_Features_Draw_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Draw_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_features_draw_desc(inputs)
});
export { home_features_draw_desc as "home.features.draw_desc" }